import { attemptChunkReload, isChunkLoadError } from 'utils/extra/chunkReload';
import logError from 'utils/extra/logError';

function handlePossibleChunkError(error) {
  if (!isChunkLoadError(error)) return;
  if (attemptChunkReload()) return;
  logError(error instanceof Error ? error : new Error('ChunkLoadError'), {
    chunk: true,
    suppressed: true,
  });
}

// Catches a failed chunk load that never reaches a React error boundary -
// notably @segment/analytics-next's own internal dynamic imports, which run
// outside our component tree entirely. A failed <script> surfaces to
// window.onerror as an Event (capture phase only); a failed dynamic
// import()/fetch() surfaces as an unhandled rejection. See
// src/utils/extra/chunkReload.js and docs/NETLIFY_MIGRATION.md, §9.
//
// Registered via addEventListener, not window.onerror, because
// src/context/AuthContext.js already assigns window.onerror directly and a
// second assignment would clobber it.
export function setupGlobalEvents() {
  window.addEventListener(
    'error',
    (event) => handlePossibleChunkError(event.error || event),
    true,
  );

  window.addEventListener('unhandledrejection', (event) =>
    handlePossibleChunkError(event.reason),
  );
}
